import { IOfflineStorage } from 'src/offline-storage';
import { UserSettings } from 'src/types/UserSettings';
import { USER_SETTINGS } from 'src/components/constants';
import { parseProp } from 'src/utils/parseProp';
import { isUserSettings } from 'src/utils/isUserSettings';

export async function loadUserSettingsFromLS(offlineStorage: IOfflineStorage): Promise<UserSettings | null> {
  const serializedSettings = await offlineStorage.get(USER_SETTINGS);
  return parseProp<UserSettings | null>(serializedSettings, isUserSettings, null);
}
